import React from 'react';
import { NonBusinessSiteRow } from '../../services/webFilter.service';
import { useTableSort, sortIndicator } from '../../lib/tableSort';

interface Props {
  rows: NonBusinessSiteRow[];
  isPdfMode?: boolean;
}

const WfNonBusinessSites: React.FC<Props> = ({ rows, isPdfMode }) => {
  const { sorted, sortKey, sortDir, onSort } = useTableSort<NonBusinessSiteRow>(rows);
  // PDF 모드에서는 원본 순서 유지(정렬 비활성)
  const display = isPdfMode ? rows : sorted;

  const headerProps = (key: keyof NonBusinessSiteRow) =>
    isPdfMode
      ? {}
      : { onClick: () => onSort(key), style: { cursor: 'pointer', userSelect: 'none' as const } };
  const ind = (key: keyof NonBusinessSiteRow) =>
    isPdfMode ? null : <span className="wf-sort-ind">{sortIndicator(sortKey, key, sortDir)}</span>;

  return (
    <div className={`wf-section-card ${isPdfMode ? 'pdf-page-break' : ''}`}>
      {isPdfMode && <h2 className="wf-pdf-section-title">📑 비업무사이트 검토 내역</h2>}
      <h3>■ 웹사이트 접속 현황 내 비업무 사이트</h3>
      <table className="wf-data-table">
        <thead>
          <tr>
            <th>No.</th>
            <th {...headerProps('companyName')}>계열사 {ind('companyName')}</th>
            <th {...headerProps('host')}>호스트 {ind('host')}</th>
            <th {...headerProps('category')}>카테고리 {ind('category')}</th>
            <th {...headerProps('issue')}>이슈사항 {ind('issue')}</th>
          </tr>
        </thead>
        <tbody>
          {display.length === 0 ? (
            <tr>
              <td colSpan={5} className="wf-empty-cell">데이터가 없습니다.</td>
            </tr>
          ) : (
            display.map((r, idx) => (
              <tr key={r.id}>
                <td>{r.seqNo ?? idx + 1}</td>
                <td>{r.companyName ?? '-'}</td>
                <td>{r.host ?? '-'}</td>
                <td>{r.category ?? '-'}</td>
                <td>{r.issue ?? '-'}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default WfNonBusinessSites;
